import { AdminNavigationSetup } from "@dust-tt/front/components/layouts/AdminNavigationSetup";
import { HomeRouterLayout } from "@spa/app/layouts/HomeRouterLayout";
import { withSuspense } from "@spa/app/routes/withSuspense";
import type { RouteObject } from "react-router-dom";
import { Outlet } from "react-router-dom";

const RoutinesPage = withSuspense(
  () => import("@dust-tt/front/components/pages/routines/RoutinesPage"),
  "RoutinesPage"
);

const RoutinePage = withSuspense(
  () => import("@dust-tt/front/components/pages/routines/RoutinePage"),
  "RoutinePage"
);

// Routines share Home's providers because the detail page links into
// sessions, and open inside the Settings modal with its menu.
export const routinesRoutes: RouteObject[] = [
  {
    element: <HomeRouterLayout />,
    children: [
      {
        element: (
          <>
            <AdminNavigationSetup />
            <Outlet />
          </>
        ),
        children: [
          { path: "routines", element: <RoutinesPage /> },
          { path: "routines/:routineId", element: <RoutinePage /> },
        ],
      },
    ],
  },
];
